import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Calendar } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Small clickable pill that surfaces the active season on the admin dashboard.
 * Clicking navigates to /seasons (Admin-only route).
 */
const CurrentSeasonPill = () => {
  const navigate = useNavigate();
  const [season, setSeason] = useState(null);

  useEffect(() => {
    const h = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    axios.get(`${API}/api/seasons/current`, h).then((r) => setSeason(r.data)).catch(() => {});
  }, []);

  if (!season) return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/seasons')}
      className="inline-flex items-center gap-2 rounded-full border border-emerald-200 dark:border-emerald-900/50 bg-emerald-50/60 dark:bg-emerald-900/20 px-3 py-1 text-xs text-emerald-800 dark:text-emerald-200 hover:bg-emerald-100 dark:hover:bg-emerald-900/30 transition-colors"
      data-testid="current-season-pill"
    >
      <Calendar size={12} className="text-emerald-600 dark:text-emerald-400" />
      <span className="font-medium" data-testid="current-season-name">{season.name}</span>
      <span className="text-[10px] text-emerald-700/70 dark:text-emerald-300/70">
        · {season.athlete_count ?? 0} on roster · change
      </span>
    </button>
  );
};

export default CurrentSeasonPill;
